import React, { useEffect } from "react";
import './index.scss';
import { Col, Row, Typography } from "antd";
import ProductDetail from "@components/ProductDetail";
import BitResults from "@components/BitResults";
import EmptyData from "@components/EmptyData";
import { useQuery } from "react-query";
import { getFinishedProduct } from "dataLayer/product";
import { useTranslation } from "react-i18next";

const { Title } = Typography;

const HistoryPage = () => {
  const { t } = useTranslation();
  const { data: products } = useQuery(getFinishedProduct());

  useEffect(() => {
    document.title = t("title.finished");
  }, [t]);
  return (
    <div className="history-page">
      <div className="history-page-wrapper">
        <Row justify="center">
          <Col xs={24}>
            <Title level={2} className="history-page-title">
              {t("finished")}{" "}
              <span className="number">{products?.length || 0}</span>
            </Title>
            {products?.length > 0 && (
              <Row gutter={[0, 40]}>
                {products.map((product, index) => (
                  <Col md={24} key={`history-item-${index}`}>
                    <div className="history-item">
                      <Row gutter={[60, 0]}>
                        <Col xs={24} md={24} lg={12} xl={15} xxl={17}>
                          <div className="history-item-product">
                            <ProductDetail
                              product={product}
                              isHistoryOverview={true}
                              isPotentialWinner={false}
                            />
                          </div>
                        </Col>
                        <Col xs={24} md={24} lg={12} xl={9} xxl={7}>
                          <BitResults product={product} />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                ))}
              </Row>
            )}
            {products?.length === 0 && <EmptyData />}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HistoryPage;
